/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _9 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>9 - Правила оформления кода</h2>
    <p className={styles.description}>
      Оформление HTML и CSS документов - это важный вопрос. В первую очередь, важный для разработчика. Ведь в процессе
      работы над созданием веб-ресурсов достаточно часто необходимо возвращаться к уже написанному коду. В подавляющем
      большинстве проектов больше чем 1 разработчик. А если код не оформлен - он теряет читабельность и, как следствие,
      скорость разработки падает.
    </p>
    <p className={styles.notificationWarn}>
      Данный курс требует качественного оформления кода, сохраните этот{' '}
      <a className={styles.link} target="_blank" rel="noopener noreferrer" href="http://sadcitizen.me/code-guide/">
        Style Guide
      </a>{' '}
      и следуйте ему по мере изучения технологий.
    </p>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>9.1 - Комментарии</h3>
      <p className={styles.description}>
        Часто бывет необходимым прокомментировать написанный код - сделать подпись, разделить исходный текст на блоки,
        т.д., но при этом, чтобы такие комментарии не были видны пользователям, которые смотрят итоговый документ в
        браузере.
      </p>
      <p className={styles.description}>
        В HTML, текст комментария заключается между специальными разделителями, текст между которыми отображаться не
        будет.
      </p>
      <iframe
        height="300"
        scrolling="no"
        title="rotman_html_1_9_1"
        src="https://codepen.io/rotmanyan/embed/QWqWwKE?default-tab=html%2Cresult&editable=true&theme-id=dark"
        frameBorder="no"
        loading="lazy"
        allowTransparency="true"
        allowFullScreen="true"
      />
    </section>
  </section>
))
